
/* styles */
require("!!../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../node_modules/vue-loader/lib/style-rewriter?id=data-v-a5c1d08a&scoped=true!../node_modules/vue-loader/lib/selector?type=styles&index=0!./StockPage.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./StockPage.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-a5c1d08a!../node_modules/vue-loader/lib/selector?type=template&index=0!./StockPage.vue"),
  /* scopeId */
  "data-v-a5c1d08a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/StockPage.vue
// module id = 297
// module chunks = 2